import Constant from '@/const'
export default {
  namespaced: true,

  state: {
    cityList: [],
  },

  mutations: {
    /** 市区町村更新 */
    updateCityList(state, val) {
      state.cityList = val
    },
  },

  actions: {
    // 郵便番号から地区情報を取得
    getAreaFromZipCd({ commit, dispatch }, zipCd) {
      const request = {
        url: `${Constant.API_URL.ZIP}/${zipCd}`,
        error: { message: 'エリア情報の取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (res) => {
          return res.data ? res.data[0] : null
        }
      )
    },

    // 市区町村取得
    getCityList({ commit, dispatch }, prefCd) {
      const request = {
        url: `${Constant.API_URL.CITY}/${prefCd}`,
        error: { message: '市区町村マスタの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (res) => {
          if (!res.data) return null
          const cityList = res.data.map((v) => {
            return {
              text: v.SHIKU_MEI,
              value: v.SHIKU_CD,
            }
          })
          commit('updateCityList', cityList)
          return res
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/address.js